<div class="breadcrumb-area">
	<h1>Pago de Cuentas por Pagar</h1>
</div>
<div class="card mb-2" id="receivable-data">
    <div class="card-body">
		<!-- Tipo de Documento -->
		<div class="mb-3">
			<label for="isReceipt" class="form-label">Tipo de Documento</label>
			<div class="input-group">
			<button (click)="isReceipt = !isReceipt"
				[ngClass]="isReceipt ? 'btn-primary' : 'btn-secondary'" class="btn">
				<i [ngClass]="isReceipt ? 'fa-toggle-on' : 'fa-toggle-off'" class="fa"></i>
			</button>
			<input type="text" style="user-select: none;" disabled name="isReceipt" id="isReceipt"
				[value]="isReceipt ? 'RECIBO' : 'ANTICIPO'" class="form-control">
			</div>
		</div>
		<div class="form-group">
			<label for="client-input" class="form-label">Proveedor</label>
			<div class="input-group input-group-sm" style="margin-bottom: 1em;">
				<app-input-autocomplete [ruleToDisabled]="clients.length == 0" [allBorderRadius]="true"
					[inputs]="client" [placeholder]="'Ingresa el nit o el nombre de un proveedor'"
					[filterElements]="client.filterElements" [typeElements]="'client'" (inputMethod)="writeClient()"
					(changeStatus)="selectClient($event.filterElement,1)" [custom]="true">
					<ng-template #itemsTemplate let-filter>
						<!-- This is the content that will be projected -->
						<div items>
							<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
								{{filter.name}}</h5>
							<span style="color: white;">NIT: <b>{{filter.nit}}</b></span>
						</div>
					</ng-template>
				</app-input-autocomplete>
			</div>
		</div>
		<div *ngIf="!clientSelected">
			<div class="row" style="color: var(--bs-bg-servicios)">
			  <div class="col-sm-10">
				<span class="display-4"> Selecciona el proveedor que saldará su cuenta </span>
			  </div>
			  <div class="col-sm-2 d-flex justify-content-center align-items-center">
				<span class="display-2">
				  <i class="fa fa-hand-pointer bouncing-hand"></i>
				</span>
			  </div>
			</div>
		</div>
		<div></div>
			<div class="card mb-3" *ngIf="clientSelected">
				<div class="card-body d-flex justify-content-between align-items-center">
					<div>
					  <h5 class="card-title">Datos del proveedor</h5>
					  <h5 class="card-title">{{ clientSelected.name }}</h5>
					  <p class="card-text">
						<strong>NIT:</strong> {{ clientSelected.nit }}<br />
						<strong>Código:</strong> {{ clientSelected.code }}<br />
					  </p>
					</div>
				  
					<!-- Resumen de seleccionados -->
					<div *ngIf="getSelectedSummary().count > 0" class="text-end">
					  <p class="mb-0"><strong>Seleccionados:</strong> {{ getSelectedSummary().count }}</p>
					  <p class="mb-0">
						<strong>Total:</strong>
						{{ getSelectedSummary().total | currency:'Q. ':'symbol':'1.2-2' }}
					  </p>
					</div>
				  </div>				  
			</div>
			<div *ngIf="clientSelected == null">
				<!-- Resumen de seleccionados si no hay cliente seleccionado -->
				<div *ngIf="getSelectedSummary().count > 0" class="text-end">
				<p class="mb-0"><strong>Seleccionados:</strong> {{ getSelectedSummary().count }}</p>
				<p class="mb-0">
					<strong>Total:</strong>
					{{ getSelectedSummary().total | currency:'Q. ':'symbol':'1.2-2' }}
				</p>
				</div>
			</div>

			<!-- Tabs -->
			<ul class="nav nav-tabs">
			  <li class="nav-item" (click)="activeTab = 'invoices'">
				<a class="nav-link" [class.active]="activeTab === 'invoices'">Facturas Gasto</a>
			  </li>
			  <li class="nav-item" (click)="activeTab = 'provider'">
				<a class="nav-link" [class.active]="activeTab === 'provider'">Facturas Proveedor</a>
			  </li>
			  <li class="nav-item" (click)="activeTab = 'lots'">
				<a class="nav-link" [class.active]="activeTab === 'lots'">Lotes</a>
			  </li>
			  <li class="nav-item" (click)="activeTab = 'loans'">
				<a class="nav-link" [class.active]="activeTab === 'loans'">Préstamos</a>
			  </li>
			  <li class="nav-item" (click)="activeTab = 'notes'">
				<a class="nav-link" [class.active]="activeTab === 'notes'">Notas de Débito</a>
			  </li>
			</ul>
		  
			<!-- Tab content -->
			<div class="tab-content p-3 border border-top-0">
				<div *ngIf="activeTab === 'invoices'">
					<div *ngIf="data.expenseInvoices.length > 0">
						<h5>Facturas</h5>
						<button class="btn btn-sm btn-outline-primary mb-2" (click)="selectAllActive()">
							{{ areAllSelected() ? 'Deseleccionar todo' : 'Seleccionar todo' }}
						</button>						  
						<div style="max-height: 300px; overflow-y: auto;">
						<table class="table table-striped">
							<thead>
							<tr>
								<th></th>
								<th>Fecha</th>
								<th>Número</th>
								<th>Monto Restante</th>
							</tr>
							</thead>
							<tbody>
							<tr *ngFor="let invoice of data.expenseInvoices" 
							(click)="toggleSelection(invoice)"
							[class.selected-row]="invoice.selected">
								<td><input type="checkbox" [(ngModel)]="invoice.selected" (click)="toggleSelection(invoice); $event.stopPropagation()"/></td>
								<td>{{ formatDate(invoice.docDate) }}</td>
								<td>{{ invoice.sDoc }} {{ invoice.noDoc }}</td>
								<td>{{ invoice.balance | currency:'Q. ':'symbol':'1.2-2' }}</td>
							</tr>
							</tbody>
						</table>
						</div>
					</div>
					<div *ngIf="data.expenseInvoices.length === 0">
						<h5>No hay facturas de proveedor</h5>
					</div>
				</div>

				<div *ngIf="activeTab === 'provider'">
					<div *ngIf="data.providerInvoices.length > 0">
					  <h5>Facturas</h5>
					  <button class="btn btn-sm btn-outline-primary mb-2" (click)="selectAllActive()">
						{{ areAllSelected() ? 'Deseleccionar todo' : 'Seleccionar todo' }}
					  </button>	
					  <div style="max-height: 300px; overflow-y: auto;">
						<table class="table table-striped">
						  <thead>
							<tr>
							  <th></th>
							  <th>Fecha</th>
							  <th>Número</th>
							  <th>Monto Restante</th>
							</tr>
						  </thead>
						  <tbody>
							<tr *ngFor="let invoice of data.providerInvoices"
								(click)="toggleSelection(invoice)"
								[class.selected-row]="invoice.selected">
							  <td><input type="checkbox" [(ngModel)]="invoice.selected" (click)="toggleSelection(invoice); $event.stopPropagation()"/></td>
							  <td>{{ formatDate(invoice.accountingDate) }}</td>
							  <td>{{ invoice.series }} {{ invoice.number }}</td>
							  <td>{{ invoice.balance | currency:getCurrencySymbol(invoice.currency):'symbol':'1.2-2' }}</td>
							</tr>
						  </tbody>
						</table>
					  </div>
					</div>
				  
					<div *ngIf="data.providerInvoices.length === 0">
					  <h5>No hay facturas de proveedor</h5>
					</div>
				</div>

				<div *ngIf="activeTab === 'lots'">
					<div *ngIf="lots.length > 0">
					  <h5>Lotes</h5>
					  <button class="btn btn-sm btn-outline-primary mb-2" (click)="selectAllActive()">
						{{ areAllSelected() ? 'Deseleccionar todo' : 'Seleccionar todo' }}
					  </button>	
					  <div style="max-height: 300px; overflow-y: auto;">
						<table class="table table-striped">
						  <thead>
							<tr>
							  <th></th>
							  <th>Fecha</th>
							  <th>Nombre</th>
							  <th>Monto Restante</th>
							</tr>
						  </thead>
						  <tbody>
							<tr *ngFor="let lot of lots"
								(click)="toggleSelection(lot)"
								[class.selected-row]="lot.selected">
							  <td><input type="checkbox" [(ngModel)]="lot.selected" (click)="toggleSelection(lot); $event.stopPropagation()"/></td>
							  <td>{{ formatDate(lot.date) }}</td>
							  <td>{{ lot.lotName }}</td>
							  <td>{{ lot.totalPaid | currency:'Q. ':'symbol':'1.2-2' }}</td>
							</tr>
						  </tbody>
						</table>
					  </div>
					</div>
				  
					<div *ngIf="lots.length === 0">
					  <h5>No hay lotes cargados</h5>
					</div>
				</div>

				<div *ngIf="activeTab === 'loans'">
					<div *ngIf="data.loans.length > 0">
					  <h5>Préstamos</h5>
					  <button class="btn btn-sm btn-outline-primary mb-2" (click)="selectAllActive()">
						{{ areAllSelected() ? 'Deseleccionar todo' : 'Seleccionar todo' }}
					  </button>	
					  <div style="max-height: 300px; overflow-y: auto;">
						<table class="table table-striped">
						  <thead>
							<tr>
							  <th></th>
							  <th>Fecha</th>
							  <th>Documento</th>
							  <th>Monto Restante</th>
							</tr>
						  </thead>
						  <tbody>
							<tr *ngFor="let loan of data.loans"
								(click)="toggleSelection(loan)"
								[class.selected-row]="loan.selected">
							  <td><input type="checkbox" [(ngModel)]="loan.selected" (click)="toggleSelection(loan); $event.stopPropagation()"/></td>
							  <td>{{ formatDate(loan.date) }}</td>
							  <td>{{ loan.series }} {{ loan.document }}</td>
							  <td>{{ loan.balance | currency:'Q. ':'symbol':'1.2-2' }}</td>
							</tr>
						  </tbody>
						</table>
					  </div>
					</div>
				  
					<div *ngIf="data.loans.length === 0">
					  <h5>No hay préstamos</h5>
					</div>
				</div>

				<div *ngIf="activeTab === 'notes'">
					<div *ngIf="data.notes.length > 0">
					  <h5>Notas de Debito</h5>
					  <button class="btn btn-sm btn-outline-primary mb-2" (click)="selectAllActive()">
						{{ areAllSelected() ? 'Deseleccionar todo' : 'Seleccionar todo' }}
					  </button>	
					  <div style="max-height: 300px; overflow-y: auto;">
						<table class="table table-striped">
						  <thead>
							<tr>
							  <th></th>
							  <th>Fecha</th>
							  <th>Numero</th>
							  <th>Monto Restante</th>
							</tr>
						  </thead>
						  <tbody>
							<tr *ngFor="let note of data.notes"
								(click)="toggleSelection(note)"
								[class.selected-row]="note.selected">
							  <td><input type="checkbox" [(ngModel)]="note.selected" (click)="toggleSelection(note); $event.stopPropagation()"/></td>
							  <td>{{ formatDate(note.date) }}</td>
							  <td>{{ note.invoice }}</td>
							  <td>{{ note.balance | currency:'Q. ':'symbol':'1.2-2' }}</td>
							</tr>
						  </tbody>
						</table>
					  </div>
					</div>
				  
					<div *ngIf="data.notes.length === 0">
					  <h5>No hay notas de debito</h5>
					</div>
				</div>

			</div>
		  
			<!-- Datos fijos -->
			<div class="mt-4">
				<div class="mt-4">
					<!-- Tipo de documento fijo -->
					<div>
					  <label>Tipo de Documento</label>
					  <h4>{{isReceipt ? "Recibo" : "Anticipo"}}</h4>
					</div>
				  
					<!-- Caja si es recibo -->
					<div *ngIf="isReceipt">
						<label for="cash">Caja:
						<span style="color: red;" data-tooltip="Campo requerido" data-tooltip-position="top">*</span>
						</label>
						<select name="cashier1" id="cashier1" [(ngModel)]="cashSelected" class="form-select">
						<option [ngValue]="undefined">Seleccione una caja</option>
						<option *ngFor="let cash of cashiers" [ngValue]="cash.id">{{ cash.name }}</option>
						</select>
					</div>
					
					<!-- Avances si es anticipo -->
					<div *ngIf="!isReceipt">
						<label for="advance">Buscar Anticipo:</label>
						<input
						type="text"
						id="advance"
						class="form-control mb-2"
						[(ngModel)]="advanceSearch"
						(input)="filterAdvances()"
						placeholder="Buscar por descripción, monto o banco"
						/>
						<div style="max-height: 200px; overflow-y: auto; border: 1px solid #ccc; border-radius: 5px; padding: 5px;">
						<div *ngFor="let advance of filteredAdvances" 
							(click)="advanceSelected = advance"
							[ngClass]="{'bg-primary text-white': advanceSelected?.docId === advance.docId}"
							style="padding: 8px; margin-bottom: 5px; cursor: pointer; border-radius: 5px;">
							<div><strong>{{ advance.description }}</strong></div>
							<div *ngIf="advance.beneficiary">Beneficiario: {{ advance.beneficiary }}</div>
							<div>Banco: {{ advance.rootLocation }}</div>
							<div>Monto: {{ advance.amount | currency:'Q. ':'symbol':'1.2-2' }}</div>
						</div>
						<div *ngIf="filteredAdvances.length === 0" class="text-muted">
							No se encontraron avances...
						</div>
						</div>
					</div>
				  
					<!-- Documento -->
					<div *ngIf="isReceipt">
					  <label>Documento:</label>
					  <input
						type="text"
						class="form-control"
						placeholder="Ingrese el número de recibo"
						[(ngModel)]="documentNumber"
					  />
					</div>

					<!-- Monto -->
					<div>
						<label>Monto
						  <span *ngIf="calculatedAmount"> (Sugerido: {{ calculatedAmount | currency:'Q. ':'symbol':'1.2-2' }})</span>
						</label>
						<input type="number" class="form-control" [(ngModel)]="amount" (input)="onAmountInput()" />
					</div>
				  
					<!-- Fecha -->
					<div>
					  <label>Fecha</label>
					  <input type="date" class="form-control" [(ngModel)]="entryDate" (change)="getExchangeRate()"/>
					</div>
				  
					<!-- Descripción -->
					<div>
					  <label>Descripción</label>
					  <input type="text" class="form-control" [(ngModel)]="description" />
					</div>

					<!-- Dólares y Tipo de cambio -->
					<div class="d-flex align-items-center mb-3">
						<div class="form-check form-switch me-3">
						  <input
							class="form-check-input"
							type="checkbox"
							role="switch"
							id="dollarSwitch"
							[(ngModel)]="isDollar"
						  />
						  <label class="form-check-label" for="dollarSwitch">Dólares</label>
						</div>
					  
						<div class="d-flex align-items-center" *ngIf="isDollar">
						  <label class="me-2 mb-0">Tipo de Cambio</label>
						  <input
							*ngIf="isDollar"
							type="number"
							class="form-control"
							style="width: 150px;"
							[(ngModel)]="exchangeRate"
							placeholder="0.0000"
						  />
						</div>
					</div>
				</div>
		  
			<!-- Botón para enviar -->
			<button class="btn btn-primary mt-3" (click)="sendSelected()">Enviar selección</button>
		  	</div>
    </div>
</div>